import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { LayoutDashboard, BarChart3, Settings, Menu } from "lucide-react";

function AdminSidebar() {
  const [collapsed, setCollapsed] = useState(true);

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--admin-sidebar-width",
      collapsed ? "5rem" : "16rem"
    );
  }, [collapsed]);

  const linkClass = ({ isActive }) =>
    `flex items-center gap-3 rounded-xl px-4 py-3 font-semibold transition ${
      isActive
        ? "bg-yellow-400 text-black"
        : "text-neutral-300 hover:bg-white/10 hover:text-white"
    }`;

  return (
    <aside
      className={`fixed left-0 top-0 z-50 h-screen border-r border-white/10 bg-neutral-950 p-4 text-white transition-all duration-300 ${
        collapsed ? "w-20" : "w-64"
      }`}
    >
      <div className="mb-8 flex items-center justify-between">
        {!collapsed && (
          <div>
            <h2 className="text-2xl font-bold text-yellow-400">
              Taxi Admin
            </h2>
            <p className="text-sm text-neutral-500">
              Management Panel
            </p>
          </div>
        )}

        <button
          onClick={() => setCollapsed(!collapsed)}
          className="rounded-xl border border-white/10 bg-neutral-900 p-3 text-white hover:bg-white/10"
        >
          <Menu size={22} />
        </button>
      </div>

      <nav className="space-y-3">
        <NavLink to="/admin" end className={linkClass}>
          <LayoutDashboard size={22} />
          {!collapsed && <span>Dashboard</span>}
        </NavLink>

        <NavLink to="/admin/analytics" className={linkClass}>
          <BarChart3 size={22} />
          {!collapsed && <span>Analytics</span>}
        </NavLink>

        <NavLink to="/admin/settings" className={linkClass}>
          <Settings size={22} />
          {!collapsed && <span>Settings</span>}
        </NavLink>
      </nav>
    </aside>
  );
}

export default AdminSidebar;
